module.exports = __webpack_public_path__ + "static/media/empty-bottle.734f0124.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/empty-bottle.png
// module id = 725
// module chunks = 0